import axios from "axios";
import { carepApi } from "./helper";
const client = axios.create({
  baseURL: carepApi,
  withCredentials: false
});

client.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    return Promise.reject(error.response);
  }
);

// Referral

function GetReferral(id) {
  const params = {
    id: id,
    action: "public"
  };
  return client.get("referrals.php", { params });
}

// Repair
function GetRepair(id) {
  const params = {
    id: id,
    action: "public"
  };
  return client.get("repairs.php", { params });
}

function GetRepairStages(id) {
  const params = {
    id: id,
    action: "publicstages"
  };
  return client.get("repairs.php", { params });
}

function GetFiles(sourcetype, sourceId, sourcedetId) {
    const params = {
      sourcetype: sourcetype,
      sourceId: sourceId,
      sourcedetId: sourcedetId,
      action: "files"
    };
    return client.get("files.php", { params });
  }
  
  function GetFilesPublic(id) {
    const params = {
      id: id,
      action: "public"
    };
    return client.get("files.php", { params });
  }
  

export { GetReferral, GetRepair, GetRepairStages,GetFiles ,GetFilesPublic }